import { useMutation, useQuery } from '@apollo/client';
import { Empty, message } from 'antd';

import {
  CasesSendReportV1ChecklistContainerSendReportCaseV1Document,
  CasesSendReportV1ChecklistContainerSendReportCaseV1UpdateDocument,
  SendReportCaseV1UpdateInput,
  CasesSendReportV1ChecklistContainerSendReportCaseV1FieldsFragment,
  SendReportCaseV1CaseDetailsApplicationReviewInput
} from '../../../../../../generated';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { Checklist } from './checklist';
import { useState } from 'react';

interface ChecklistContainerProps {
  caseId: string;
}

export const ChecklistContainer: React.FC<ChecklistContainerProps> = (props) => {
  const [isSuccess, setIsSuccess] = useState(false as boolean);
  const {
    data: caseData,
    loading: caseLoading,
    error: caseError
  } = useQuery(CasesSendReportV1ChecklistContainerSendReportCaseV1Document, {
    variables: {
      id: props.caseId
    }
  });

  const [sendReportUpdate] = useMutation(CasesSendReportV1ChecklistContainerSendReportCaseV1UpdateDocument);

  const handleComplete = async (values: SendReportCaseV1CaseDetailsApplicationReviewInput) => {
    try {
      const sendReportUpdateVariables: SendReportCaseV1UpdateInput = {
        id: props.caseId,
        caseDetails: {
          applicationReview: {
            ...values
          }
        }
      };
      const result = await sendReportUpdate({
        variables: { input: sendReportUpdateVariables }
      });
      if (result.data?.sendReportCaseV1Update?.status.success) {
        setIsSuccess(result.data?.sendReportCaseV1Update?.status?.success as boolean);
        message.success('Affirmations saved successfully');
      } else {
        message.error(`Error saving Affirmations: ${result.data?.sendReportCaseV1Update?.status.errorMessage}`);
      }
    } catch (error) {
      message.error(`Error saving Affirmations: ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      loading={caseLoading}
      error={caseError}
      hasData={!!caseData}
      hasDataComponent={
        <Checklist data={caseData?.sendReportCaseV1 as CasesSendReportV1ChecklistContainerSendReportCaseV1FieldsFragment} onSave={handleComplete} isSuccess={isSuccess} />
      }
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
